import { ISurveyDetail } from "../../app/models/survey";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";

// reactstrap components
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { SurveyResposeForm } from "./SurveyResponseForm";
import { RootStoreContext } from "../../app/stores/rootStore";
import classnames from "classnames";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../../app/localization/localization";

interface IProps {
  surveyResponseId: number;
  isOpen: boolean;
  survey: ISurveyDetail;
  languages: Number[];
  toggle: () => void;
  onSubmit: () => void;
}

const SurveyResponseEditModal: React.FC<IProps> = ({
  surveyResponseId,
  isOpen,
  toggle,
  survey,
  onSubmit,
  languages,
}) => {
  const isEditMode = surveyResponseId > 0;
  const rootStore = useContext(RootStoreContext);
  const {theme} =rootStore.commonStore;
  const [t] = useTranslation(["surveys"], translationHookOptions);
  
  return (
    <>
      <Modal
        className="modal-dialog-centered"
        isOpen={isOpen}
        toggle={toggle}
        size="lg"
      >
        <ModalHeader
          style={{height:"10px"}}
          className={classnames( `${theme!.headerModal} ${theme!.headerTextColor}`)}
          toggle={() => toggle()}
          close={
            <button className="closeModalIcon" onClick={() => toggle()}>
              <i className="far fa-times-circle fa-lg"></i>
            </button>
          }
        >
          <h5 className="modal-title" id="exampleModalLabel">
            {isEditMode ? t("answer_modal_title_edit") : t("answer_modal_title_add")}
          </h5>
        </ModalHeader>

        <ModalBody>
          <SurveyResposeForm
            languages={languages}
            surveyResponseId={surveyResponseId}
            survey={survey}
            onSubmit={onSubmit}
          ></SurveyResposeForm>
        </ModalBody>
      </Modal>
    </>
  );
};

export default observer(SurveyResponseEditModal);
